import { ACTIVITY_EMIT_THROTTLE_MS } from '@/lib/session/constants';

type Listener = (activityAt: number) => void;
const listeners = new Set<Listener>();

let lastNotifyAt = 0;
let trailingActivityAt: number | undefined;
let trailingTimer: ReturnType<typeof setTimeout> | undefined;

function notifyListeners(activityAt: number) {
    listeners.forEach((listener) => listener(activityAt));
}

function scheduleTrailingEmit(delayMs: number) {
    if (trailingTimer !== undefined) {
        return;
    }

    trailingTimer = setTimeout(() => {
        trailingTimer = undefined;
        lastNotifyAt = Date.now();
        const activityAt = trailingActivityAt ?? lastNotifyAt;
        trailingActivityAt = undefined;
        notifyListeners(activityAt);
    }, delayMs);
}

export const activityBus = {
    emit: () => {
        const now = Date.now();
        const elapsed = now - lastNotifyAt;

        if (lastNotifyAt === 0 || elapsed >= ACTIVITY_EMIT_THROTTLE_MS) {
            lastNotifyAt = now;
            trailingActivityAt = undefined;
            if (trailingTimer !== undefined) {
                clearTimeout(trailingTimer);
                trailingTimer = undefined;
            }
            notifyListeners(now);
            return;
        }

        trailingActivityAt = now;
        scheduleTrailingEmit(ACTIVITY_EMIT_THROTTLE_MS - elapsed);
    },
    subscribe: (listener: Listener): (() => void) => {
        listeners.add(listener);
        return () => {
            listeners.delete(listener);
        };
    },
};
